/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateReportRequest } from '../models/CreateReportRequest';
import type { Report } from '../models/Report';
import type { ReportCompositeDataResponse } from '../models/ReportCompositeDataResponse';
import type { ReportCutsDataResponse } from '../models/ReportCutsDataResponse';
import type { ReportTag } from '../models/ReportTag';
import type { UpdateReportRequest } from '../models/UpdateReportRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ReportService {

    /**
     * Get list of reports
     * @returns any Success
     * @throws ApiError
     */
    public static getReports({
        limit,
        offset,
        ignorePagination,
        tags,
        search,
    }: {
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
        /**
         * ignore Pagination flag
         */
        ignorePagination?: boolean,
        /**
         * Search Tags
         */
        tags?: Array<number>,
        /**
         * Search
         */
        search?: string,
    }): CancelablePromise<{
        reports?: Array<Report>;
        globalReports?: Array<Report>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/report',
            query: {
                'limit': limit,
                'offset': offset,
                'ignorePagination': ignorePagination,
                'tags': tags,
                'search': search,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Unauthorized`,
            },
        });
    }

    /**
     * Create report
     * @returns Report Success
     * @throws ApiError
     */
    public static createReport({
        requestBody,
    }: {
        requestBody: CreateReportRequest,
    }): CancelablePromise<Report> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/report',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }

    /**
     * Get report
     * @returns Report Success
     * @throws ApiError
     */
    public static getReport({
        reportId,
        isGlobal,
    }: {
        /**
         * Report ID
         */
        reportId: number,
        /**
         * Is Global Report
         */
        isGlobal?: boolean,
    }): CancelablePromise<Report> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/report/{reportId}',
            path: {
                'reportId': reportId,
            },
            query: {
                'isGlobal': isGlobal,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete Report
     * @returns any Success
     * @throws ApiError
     */
    public static deleteReport({
        reportId,
    }: {
        /**
         * Report ID
         */
        reportId: number,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/report/{reportId}',
            path: {
                'reportId': reportId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update Report
     * @returns Report Success
     * @throws ApiError
     */
    public static updateReport({
        reportId,
        requestBody,
    }: {
        /**
         * Report ID
         */
        reportId: number,
        requestBody: UpdateReportRequest,
    }): CancelablePromise<Report> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/report/{reportId}',
            path: {
                'reportId': reportId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * return report data
     * @returns any Success
     * @throws ApiError
     */
    public static getReportData({
        reportId,
        requestBody,
    }: {
        /**
         * Report Id
         */
        reportId: number,
        requestBody: {
            limit: number;
            offset: number;
            filter?: Record<string, any>;
            sorting?: Record<string, any>;
            isGlobal?: boolean;
        },
    }): CancelablePromise<(ReportCompositeDataResponse | ReportCutsDataResponse)> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/report/{reportId}/data',
            path: {
                'reportId': reportId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * export report data
     * @returns any Success
     * @throws ApiError
     */
    public static exportReportData({
        reportId,
        requestBody,
    }: {
        /**
         * Report Id
         */
        reportId: number,
        requestBody?: Record<string, any>,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/report/{reportId}/export',
            path: {
                'reportId': reportId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Attach tag to report
     * @returns ReportTag Success
     * @throws ApiError
     */
    public static attachReportTag({
        reportId,
        requestBody,
    }: {
        /**
         * Report Id
         */
        reportId: number,
        requestBody: {
            tags: Array<string>;
        },
    }): CancelablePromise<Array<ReportTag>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/report/{reportId}/tag',
            path: {
                'reportId': reportId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
